export default __webpack_public_path__ + "static/media/grozno_negativ.06e46610.svg";